module.exports = __webpack_public_path__ + "static/media/impreza-hero.cdd1df7a.jpg";